var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"o-content-auto-center u-mx-auto"},[(!_vm.isEmpty)?_c('div',{staticClass:"u-text-center caption u-block lg:u-w-2/3 u-mx-auto u-mt-8 u-px-6 md:u-px-16 lg:u-px-0"},[_vm._t("text")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }